module.exports = __webpack_public_path__ + "img/drone_04_H.d716a0ed.webp";